// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Calender = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Calender = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Calender = _exports.Calender = function Calender(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.6635 2.50962H14.5096V1.81731C14.5096 1.43515 14.1995 1.125 13.8173 1.125C13.4352 1.125 13.125 1.43515 13.125 1.81731V2.50962H7.125V1.81731C7.125 1.43515 6.81485 1.125 6.43269 1.125C6.05054 1.125 5.74038 1.43515 5.74038 1.81731V2.50962H4.58654C2.35454 2.50962 1.125 3.73915 1.125 5.97115V15.6635C1.125 17.8955 2.35454 19.125 4.58654 19.125H15.6635C17.8955 19.125 19.125 17.8955 19.125 15.6635V5.97115C19.125 3.73915 17.8955 2.50962 15.6635 2.50962ZM4.58654 3.89423H5.74038V4.58654C5.74038 4.96869 6.05054 5.27885 6.43269 5.27885C6.81485 5.27885 7.125 4.96869 7.125 4.58654V3.89423H13.125V4.58654C13.125 4.96869 13.4352 5.27885 13.8173 5.27885C14.1995 5.27885 14.5096 4.96869 14.5096 4.58654V3.89423H15.6635C17.1192 3.89423 17.7404 4.51546 17.7404 5.97115V6.66346H2.50962V5.97115C2.50962 4.51546 3.13085 3.89423 4.58654 3.89423ZM15.6635 17.7404H4.58654C3.13085 17.7404 2.50962 17.1192 2.50962 15.6635V8.04808H17.7404V15.6635C17.7404 17.1192 17.1192 17.7404 15.6635 17.7404Z",
      fill: "#212B36"
    }));
  };
});
